<template>
  <div class="referral-chain" @touchmove.stop="closeShowTips">
    <ul>
      <template v-for="(item, index) in referralChainInfo" >
        <li :key="'hardlink' + index">
          <div :class="{icon_pc_style : isPc}" v-if="index - 1 <= selfIndex && index > 0" class="referral-icon">
            <span class="iconfont icona-hardlink"></span>
          </div>
          <div :class="{icon_pc_style : isPc}" v-if="index - 1 > selfIndex" class="referral-icon">
            <span class="iconfont icona-softlink"></span>
          </div>
        </li>
        <li :key="index">
          <div class="candidate-info" :class="{ 'candidate-info-pc' : isPc }" style="--breath-color: #0296cc">
            <div :class="index === (referralChainInfo.length - 1) && 'breath-animation'">
              <img
                class="referral-chain-photo"
                :class="{ self: index === (referralChainInfo.length - 1) }"
                :src="[item.is_candidate ? $DjangoMediaUrl(item.profile_image_url) : item.profile_image_url]"
                @error.once="getDefaultProfilePhoto($event)"
              />
            </div>
            <span class="candidate-name" :title="item.name">{{ item.name }}</span>
            <span class="city" :title="item.city">{{ getI18nPropertyValue(item.city, 'cn_name', 'name') }}</span>
            <div
              class="personal-referral-chain-role-type"
              :class="{pc_style : isPc}"
              v-if="index === (referralChainInfo.length - 1) || item.type !== 'Lead'">
                <a v-if="item.email" :href="`mailto:${item.email}`"><span class="iconfont email">&#xe630;</span></a>
                <span
                  v-if="item.type === 'Employee'"
                  class="type"
                  :title="$t('hm.resume.referralRoleType.employee')"
                >
                  {{ $t('hm.resume.referralRoleType.employee') }}
                </span>
                <span
                  v-else-if="item.type === 'Lead'"
                  :title="$t('hm.resume.referralRoleType.lead')"
                >
                  {{ $t('hm.resume.referralRoleType.lead') }}
                </span>
                <span
                  v-else
                  :title="$t('hm.resume.referralRoleType.candidate')"
                >
                  {{ $t('hm.resume.referralRoleType.candidate') }}
                </span>
            </div>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { getI18nPropertyValue } from '../../../../i18n'

export default {
  directives: {
    Clickoutside
  },
  props: {
    referralChainInfo: {
      type: Array,
      require: true
    },
    isPc: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selfIndex: 2,
      showTips: false,
      showTipsIndex: null
    }
  },
  computed: {

  },
  created () {
    this.referralChainInfo.forEach((element, index) => {
      if (element.self === true) {
        this.selfIndex = index
      }
    })
  },
  methods: {
    getI18nPropertyValue,
    closeShowTips (index) {
      if (this.showTips && index === this.showTipsIndex) {
        this.showTips = false
      }
      this.$emit('closeShowTips')
    },
    getDefaultProfilePhoto (e) {
      e.target.src = this.$DjangoStaticUrl('images_en/default.jpg')
    }
  }
}
</script>

<style lang="scss" scoped>
.referral-chain {
  padding-top: 2px;
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(204, 211, 211, 1);
    background: rgba(152, 155, 163, 0.5);
  }

  >ul {
    display: flex;
    align-items: flex-start;

    .referral-icon {
      width: 32px;
      height: 32px;
      position: relative;
      margin-bottom: 43px;

      &.icon_pc_style {
        margin-top: 4px;

        > span {
          font-size: 40px;
        }
      }

      > span {
       font-size: 35px;
       color: rgb(2, 150, 204);
      }
    }

    >li {
      text-align: center;
      display: flex;
      max-height: 120px;
      margin-bottom: 5px;
      padding: 0px 5px 0px 5px;

      .candidate-info {
        display: flex;
        flex-direction: column;
        align-items: center;

        > div {
          margin-top: 2px;
          border-radius: 50%;
          height: 42px;
        }

        .referral-chain-photo {
          border: 1px solid white;
          border-radius: 50%;
          width: 38px;
          height: 38px;
          box-shadow: 2px 1px 4px 0px #a8b2b5;
          z-index: 1;
        }

        .self {
          box-shadow: 0 0 0px 2px #0296cc;
        }

        span {
          font-size: 10px;
          white-space: nowrap;
          width: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: 400;
          color: #333;
          line-height: 16px;
          margin: 0px;
        }

        .candidate-name {
          color: #666;
          font-size: 12px;
          margin-top: 5px;
          line-height: 1.5;
        }

        .city {
          height: 14px;
        }

        .personal-referral-chain-role-type {
          display: flex;
          align-items: center;
          justify-content: center;
          max-height: 16px;

          .iconfont {
            &.email {
              color: #0296cc;
              font-size: 16px;
            }
          }

          > span {
            margin-left: 3px;
            width: auto;
            line-height: 16px;
          }

          &.pc_style {
            background-color: #e5e5e5;
            max-height: 18px;
            border-radius: 0;
            padding: 0 2px;
          }
        }
      }

      .candidate-info-pc {
        display: flex;
        flex-direction: column;
        align-items: center;

        .candidate-name {
          color: #666666;
        }

        .city {
          color: #333333;
        }
      }

      .pc_style {
        padding-top: 2px;
        width:70px;
        text-align: center;
        display: inline-block;
        white-space: nowrap;
        vertical-align: top;
        align-items: flex-start;

        .referral-chain-photo {
          width: 40px;
          height: 40px;
          border-radius: 0;
          box-shadow: 0;
          -webkit-box-shadow: 0;
        }

        > p {
          height: 14px;
          font-size: 10px;
          font-weight: 500;
          line-height: 14px;
          margin-top: 5px;
        }
      }

      .icon_pc_style {
        margin-top: 2px;
      }
    }
  }

  .breath-animation {
    box-shadow: 0 0 10px -3px var(--breath-color);
    animation: breath 3s linear infinite;
  }

  @keyframes breath {
    from {
      opacity: .8;
      box-shadow: 0 0 10px -3px var(--breath-color);
    }
    25% {
      box-shadow: 0 0 9px 0px var(--breath-color);
    }
    50% {
      opacity: 1;
      box-shadow: 0 0 8px 2px var(--breath-color);
    }
    75% {
      box-shadow: 0 0 9px 0px var(--breath-color);
    }
    to {
      opacity: .8;
      box-shadow: 0 0 10px -3px var(--breath-color);
    }
  }
}
</style>
